import { History } from 'history';
import { UserContextUser } from 'models';
import { client } from 'shared';

export function loginUser(
    username: string,
    password: string,
    refreshUser: (onComplete?: (user?: UserContextUser) => void) => void,
    history: History<any>,
    setUsernameError: (x: boolean) => void,
    setPasswordError: (x: boolean) => void,
    setLoginAttemptError: (x: boolean) => void,
    onComplete: () => void,
    onClose?: () => void,
) {
    function checkForInvalid() {
        setUsernameError(!username);
        setPasswordError(!password);
    }

    function failedLoginAttempt() {
        setLoginAttemptError(true);
    }

    function setUserToken(token: string) {
        localStorage.clear();
        localStorage.setItem('token', token);
    }

    function handleNavigation(user?: UserContextUser) {
        if (
            history.location.pathname.includes('job-request') ||
            history.location.pathname.search('/family/[1-9][0-9]*/verify') >= 0 ||
            history.location.pathname.includes('send-funds')
        ) {
            onComplete();
            onClose && onClose();
            return;
        }
        const { from } = history.location.state ?? { from: { pathname: '/home' } };
        if (user && user.signup_page === 4) {
            if (user.family || user.is_superuser) {
                history.push(from);
            }
        }

        onComplete();
    }

    if (!!username && !!password) {
        client('api/rest-auth/login/', {
            body: {
                username: username.toLocaleLowerCase(),
                password: password,
            },
        })
            .then((res) => {
                if (res.mfaToken) {
                    onClose && onClose();
                    history.push('/login/verify', { mfaToken: res.mfaToken });
                    return;
                }

                setUserToken(res.key);
                refreshUser(handleNavigation);
            })
            .catch(() => {
                failedLoginAttempt();
                onComplete();
            });
    } else {
        onComplete();
        return checkForInvalid();
    }
}
